const _computeInIframe = () => {
  try {
    // Check if URL contains /parabox/{projectId} pattern
    if (/\/parabox\/[^/]+/.test(window.location.pathname)) {
      return true
    }
    // Check if domain contains parabox (e.g., parabox-{projectId}.paraflow.biz)
    if (/^parabox/.test(window.location.hostname)) {
      return true
    }
    return window.self !== window.top
  } catch {
    return true // cross-origin iframe
  }
}

export const inIframe = _computeInIframe()
